const ELEMENT_IMAGE = '__image';
const ELEMENT_CONTENT = '__content';

const CLASS_NAME = '.fifty-fifty';
const CLASS_NAME_IMAGE = CLASS_NAME + ELEMENT_IMAGE;
const CLASS_NAME_CONTENT = CLASS_NAME + ELEMENT_CONTENT;

const $rootEl = $(CLASS_NAME);

$rootEl.each(index => {
    const $el = $rootEl.eq(index);

    // selector for all main content of the component
    const $content = $el.find(`${CLASS_NAME_IMAGE},${CLASS_NAME_CONTENT}`);
    // jquery will populate element array based on order of the DOM
    // this allows us to use the first item in the array to tell where the image is
    const firstColClasses = $content.eq(0).attr('class');
    // if the first item is the image, add class to reverse display order on mobile
    if(firstColClasses?.includes(ELEMENT_IMAGE)) {
        $el.addClass('mobile-swap-order');
    }

    const fiftyFiftyFooter = $el.find(`${CLASS_NAME}__footer`);
    if(!fiftyFiftyFooter.length <= 0) {
        const isFooterEmpty = $(fiftyFiftyFooter).html().trim().length == 0;

        if (isFooterEmpty) {
            fiftyFiftyFooter.remove();
        }
    }
    
});
